function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _pt from "prop-types";
var _excluded = ["id", "labelVisual", "icon", "active", "defaultActive", "innerRef", "className", "onBlur", "onFocus", "onClick", "children", "spacing"];
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useRef, useEffect, useState } from 'react';
import classnames from 'classnames';
import IconAccordionCaretDown from '@lmig/lmds-react-icons/dist/icons/AccordionCaretDown';
import { Transition } from 'react-transition-group';
import { uniqueId } from '@lmig/lmds-helpers';
import { useAccordionContext } from './hooks/useAccordionContext';
/**
 * @see [LMDS Accordion documentation and examples](https://designsystem.lmig.com/components/accordions/code)
 *
 * API:
 *
 * @implements [AccordionTabProps](https://designsystem.lmig.com/components/accordions/code#accordion-tab-props)
 * @extends [HTMLElement](https://microsoft.github.io/PowerBI-JavaScript/interfaces/_node_modules_typedoc_node_modules_typescript_lib_lib_dom_d_.htmlelement.html)
 */
export var AccordionTab = function AccordionTab(props) {
  var id = props.id,
    labelVisual = props.labelVisual,
    icon = props.icon,
    active = props.active,
    defaultActive = props.defaultActive,
    innerRef = props.innerRef,
    className = props.className,
    _onBlur = props.onBlur,
    _onFocus = props.onFocus,
    _onClick = props.onClick,
    children = props.children,
    _props$spacing = props.spacing,
    spacing = _props$spacing === void 0 ? 'default' : _props$spacing,
    rest = _objectWithoutProperties(props, _excluded);
  var _useAccordionContext = useAccordionContext(),
    headingAs = _useAccordionContext.headingAs,
    accordionId = _useAccordionContext.accordionId,
    handleTabStateChange = _useAccordionContext.handleTabStateChange,
    activeTabIDs = _useAccordionContext.activeTabIDs,
    compact = _useAccordionContext.compact,
    collapsible = _useAccordionContext.collapsible;
  var Heading = headingAs;
  var panelRef = useRef(null);
  // remove the `lmig-` from the accordionId if it exists to avoid duplication: lmig-lmig-accordionX-tabX
  // changed to useState because I found the id would change on each toggle of any AccordionTab within the Accordion.
  var _useState = useState(function () {
      return id || uniqueId("".concat(accordionId, "-tab").replace('lmig-', ''));
    }),
    _useState2 = _slicedToArray(_useState, 1),
    controlId = _useState2[0];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isMounted = _useState4[0],
    setIsMounted = _useState4[1];

  // Deprecation warning for legacy props
  useEffect(function () {
    if (process.env.NODE_ENV !== 'production') {
      if (typeof active !== 'undefined' || typeof defaultActive !== 'undefined') {
        console.warn('Deprecation Warning: Using the "active" or "defaultActive" props on AccordionTab is deprecated. ' + 'Please use a fully controlled Accordion by managing state via the "activePanelIds" and "onPanelChange" props on Accordion instead. ' + 'For more information, see https://designsystem.lmig.com/components/accordions/code');
      }
    }
  }, [active, defaultActive]);

  // if the active prop changes, let the parent Accordion know to handle any logic for singleTab, etc.
  useEffect(function () {
    // Only update if the incoming active prop differs from what the context already has.
    if (typeof active !== 'undefined') {
      var isActiveInContext = activeTabIDs.includes(controlId);
      if (active !== isActiveInContext) {
        handleTabStateChange({
          elementID: controlId,
          newTabState: active
        });
      }
    }
    // For the defaultActive prop, do it only on the initial mount.
    if (typeof defaultActive !== 'undefined' && !isMounted) {
      var _isActiveInContext = activeTabIDs.includes(controlId);
      if (defaultActive !== _isActiveInContext) {
        handleTabStateChange({
          elementID: controlId,
          newTabState: defaultActive
        });
      }
    }
  }, [active, defaultActive, controlId, isMounted, handleTabStateChange, activeTabIDs]);

  // local state checking against the tab array of ids
  var activeState = activeTabIDs.includes(controlId);
  useEffect(function () {
    setIsMounted(true);
  }, []);
  useEffect(function () {
    if (typeof process === 'undefined' || process.env && process.env.NODE_ENV === 'production') return;
    if (typeof active !== 'undefined' && typeof _onClick === 'undefined') {
      console.log('LMDS Accordion Tab: Consider replacing `active` with `defaultActive` to enable uncontrolled components. Alternately, add `onClick` to enable controlled components. In a future major version, setting `active` will enable controlled components regardless of whether `onClick` is set.\n\nhttps://designsystem.lmig.com/components/accordions/code');
    }
  }, [active, _onClick]);
  var scaledIcon = function scaledIcon(iconEl) {
    var sizeObj = compact ? {
      base: '16',
      sm: '24'
    } : {
      base: '24',
      sm: '32'
    };
    return /*#__PURE__*/React.cloneElement(iconEl, {
      size: sizeObj
    });
  };

  // this function is called if the consumer has an onClick, onBlur, or onFocus and needs the index of the child
  // this keeps the AccordionTab backwards compatible
  var getChildIndex = function getChildIndex(event) {
    var button = event.currentTarget;
    var listItem = button.closest('.lmig-Accordion-list-listItem');
    var parentNode = listItem.parentNode;
    return Array.from(parentNode.children).indexOf(listItem);
  };
  var isAriaDisabled = !!(activeTabIDs.length === 1 && !collapsible && activeState);
  var headerButtonClasses = classnames('lmig-Accordion-list-listItem-header-button', {
    'lmig-Accordion-list-listItem-header-button--spacing-none': spacing === 'none'
  });
  return /*#__PURE__*/React.createElement("li", {
    key: controlId,
    className: classnames('lmig-Accordion-list-listItem', {
      'lmig-Accordion--isOpen': activeState,
      'lmig-Accordion--hasIcon': icon
    })
  }, /*#__PURE__*/React.createElement(Heading, {
    className: "lmig-Accordion-list-listItem-header"
  }, /*#__PURE__*/React.createElement("button", _extends({}, rest, {
    className: headerButtonClasses,
    "aria-controls": "".concat(controlId, "-panel"),
    "aria-expanded": activeState,
    "aria-disabled": isAriaDisabled,
    id: controlId,
    onClick: function onClick(e) {
      if (isAriaDisabled) return;
      // If `active` and `onClick` are both present, treat the tab as controlled.
      // TODO: In a future major version, treat the tab as controlled if `active` is present, regardless of whether `onClick` is set.
      var newTabState = _onClick && typeof active !== 'undefined' ? active : !activeState;
      handleTabStateChange({
        elementID: controlId,
        newTabState: newTabState,
        event: e
      });
      if (_onClick) {
        _onClick(e, getChildIndex(e));
      }
    }
  }, _onBlur && {
    onBlur: function onBlur(e) {
      _onBlur(e, getChildIndex(e));
    }
  }, _onFocus && {
    onFocus: function onFocus(e) {
      _onFocus(e, getChildIndex(e));
    }
  }, {
    ref: innerRef,
    type: "button"
  }), icon && /*#__PURE__*/React.createElement("span", {
    className: "lmig-Accordion-list-listItem-header-icon"
  }, scaledIcon(icon)), /*#__PURE__*/React.createElement("span", {
    id: "".concat(controlId, "-label"),
    className: "lmig-Accordion-list-listItem-header-button-labelVisual"
  }, labelVisual), /*#__PURE__*/React.createElement("span", {
    className: "lmig-Accordion-list-listItem-header-caret"
  }, /*#__PURE__*/React.createElement(IconAccordionCaretDown, {
    size: "16",
    title: null,
    color: "teal",
    className: "lmig-Accordion-list-listItem-header-caret-svg"
  })))), /*#__PURE__*/React.createElement(Transition, {
    "in": activeState,
    timeout: 200,
    nodeRef: panelRef,
    onEnter: function onEnter() {
      panelRef.current.style.height = '0';
    },
    onEntering: function onEntering() {
      panelRef.current.style.height = "".concat(panelRef.current.scrollHeight, "px");
    },
    onEntered: function onEntered() {
      panelRef.current.style.height = null;
    },
    onExit: function onExit() {
      panelRef.current.style.height = "".concat(panelRef.current.scrollHeight, "px");
      // Reading a dimension property forces the browser to repaint, which allows the animation to work.
      panelRef.current.scrollHeight; // eslint-disable-line @typescript-eslint/no-unused-expressions
    },
    onExiting: function onExiting() {
      panelRef.current.style.height = '0';
    }
  }, function (state) {
    return /*#__PURE__*/React.createElement("div", {
      "aria-labelledby": "".concat(controlId, "-label"),
      className: classnames(className, 'lmig-Accordion-panel', _defineProperty(_defineProperty({}, "lmig-Accordion-panel--".concat(state), state), 'lmig-Accordion-panel--spacing-none', spacing === 'none')),
      hidden: state === 'exited',
      id: "".concat(controlId, "-panel"),
      role: "region",
      ref: panelRef
    }, /*#__PURE__*/React.createElement("div", {
      className: "lmig-Accordion-content"
    }, children));
  }));
};
AccordionTab.propTypes = {
  /** Add an optional ID to this element: `<div class="lmig-Accordion-panel">`. If none is provided, a unique ID will be generated. */id: _pt.string,
  /** Add custom classes to this element: `<div class="lmig-Accordion-panel">`. */className: _pt.string,
  /** Set the visual label. */labelVisual: _pt.node.isRequired,
  /** Display an icon to the left of the visual label. */icon: _pt.element,
  /**
     * @deprecated Use the fully controlled Accordion API (activePanelIds/onPanelChange) on Accordion instead.
     *
     * Set the accordion's expansion state. If `true`, the accordion is expanded. Setting both `active` and `onClick` enables controlled components.
     */
  active: _pt.bool,
  /**
     * @deprecated Use the uncontrolled Accordion API (defaultActivePanelIds) on Accordion instead.
     *
     * Set the accordion's expansion state. If `true`, the accordion is expanded. Used for uncontrolled components.
     */
  defaultActive: _pt.bool,
  /** Pass additional functionality to run on click events. */onClick: _pt.func,
  /** Pass additional functionality to run on blur events. */onBlur: _pt.func,
  /** Pass additional functionality to run on focus events. */onFocus: _pt.func,
  /** Set the content of the accordion. Children are rendered in this element: `<div class="lmig-Accordion-content">`. */children: _pt.node.isRequired,
  /** Spacing applied to the `<button className='lmig-Accordion-list-listItem-header-button' />` and `<div className='lmig-Accordion-content' />` elements.
     * @default default
     */
  spacing: _pt.oneOf(['default', 'none'])
};